module.exports = __webpack_public_path__ + "static/media/introduce.4f4280a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/marketingOnline/data/carImages/远程E6/introduce.png
// module id = 695
// module chunks = 0